import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _navProductNames;

import { NavType } from '../types';
var navProductNames = (_navProductNames = {}, _defineProperty(_navProductNames, NavType.home, ''), _defineProperty(_navProductNames, NavType.books, 'Books'), _defineProperty(_navProductNames, NavType.study, 'Study'), _defineProperty(_navProductNames, NavType.writing, 'Writing'), _defineProperty(_navProductNames, NavType.flashcards, 'Prep'), _defineProperty(_navProductNames, NavType['math-solver'], 'Math Solver'), _defineProperty(_navProductNames, NavType.internships, 'Internships'), _defineProperty(_navProductNames, NavType['test-prep'], 'Test Prep'), _defineProperty(_navProductNames, NavType.scholarships, 'Scholarships'), _defineProperty(_navProductNames, NavType.money, 'Money'), _defineProperty(_navProductNames, NavType.faculty, 'Faculty'), _defineProperty(_navProductNames, NavType.uversity, 'Uversity'), _navProductNames);
export default navProductNames;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/shared/navProductNames.js
// module id = 5612
// module chunks = 11